export default __webpack_public_path__ + "static/media/RedeemRewardRatedBG.3dfc08f9.svg";